import { render, staticRenderFns } from "./VillageSearch.vue?vue&type=template&id=59e26707&scoped=true&"
import script from "./VillageSearch.vue?vue&type=script&lang=js&"
export * from "./VillageSearch.vue?vue&type=script&lang=js&"
import style0 from "./VillageSearch.vue?vue&type=style&index=0&id=59e26707&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e26707",
  null
  
)

export default component.exports